<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <left-panel></left-panel>
    </template>
    <template v-slot:middle_view>
      <mid-global-panel></mid-global-panel>
    </template>
    <template v-slot:right_view>
      <right-panel></right-panel>
    </template>
  </BasicLayout>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import MidGlobalPanel from '@/components/mmlconfig/midPanel/MidGlobalPanel.vue';
import BasicLayout from '../../layouts/BasicLayout';
import LeftPanel from '@/components/mmlconfig/leftPanel/LeftPanel.vue';
import RightPanel from '@/components/mmlconfig/rightPanel/RightPanelGlobal.vue';
import clearMoVuex from '@/components/mmlconfig/mixins/clearMoVuex';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'MML',
  components: {
    MidGlobalPanel,
    BasicLayout,
    LeftPanel,
    RightPanel
  },
  mixins:[clearMoVuex],
  data() {
    return {
      left: {
        show: true,
        name: this.$t('MML.currentNode')
      },
      middle: {
        show: true,
        name: this.$t('MML.moTree')
      },
      right: {
        show: true,
        crumb: this.$t('MML.mml')
      },
    };
  },
  watch: {
    currentNode: {
      handler(newNe) {
        if (newNe && newNe.name) {
          this.left.name = `[${newNe.name}]`;
          return;
        }
        this.left.name = this.$t('MML.currentNode');
      },
      deep: true,
    },
    currentMo: {
      handler(newMo) {
        if (newMo && newMo.enName) {
          this.middle.name = `[${this.LOCALE === 'zh' ? newMo.zhName:newMo.enName}]`;
          return;
        }
        this.middle.name = this.$t('MML.moTree');
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters(['currentNode', 'currentMo']),
  },
  methods: {
    ...mapMutations(['changeNode',
                     'changeMo',
                     'changeCommand',
                     'changeCmdMode',
                     'changeMassModMode',
                     'changeMassChkedRecords',
                     'changeMassModExecingState',
                     'changeMmlOperButtonDisabled',
                     'changeMmlCmdButtonDisabled']),
    clearMmlVuex() {
      this.changeNode({});
      this.clearMoVuex();
    }
  },
  destroyed() {
    this.clearMmlVuex();
  }
};
</script>
